import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { GlobalAppDataStorageService } from "infra/storage";
import { Controller, useFormContext } from "react-hook-form";
import LanguageField from "./languages/LanguageField";

export default function PersonalInformation({ data }) {
    const {
        control
    } = useFormContext();

    const {
        languages,
    } = data;
    
    const vehicleOptions = GlobalAppDataStorageService.getVehicles();
    const genderOptions = GlobalAppDataStorageService.getGenders();
    
    return (
        <Box component="section" sx={{ mb: 4, width: "100%", display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>
            <Typography variant="h6" gutterBottom sx={{ gridColumn: "span 4" }}>
                Personal Information
            </Typography>
            <LanguageField languages={languages.data} />
            <Controller
                name="personalInformation.vehicles"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="personalInformation.vehicles"
                        autoComplete
                        multiple
                        fullWidth
                        options={vehicleOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Vehicle"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="personalInformation.gender"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="personalInformation.gender"
                        autoComplete
                        fullWidth
                        options={genderOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Gender"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2"},
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
        </Box>
    );
}
